import Service from './Service'
import moment from 'moment'


class RegionSupplierPriceLists extends Service {
  /** @type {Array} */
  cachedPriceLists

  /** @type {moment} */
  priceListCacheTimes

  constructor (connection) {
    super(connection)
    this.cachedPriceLists = []
    this.priceListCacheTimes = []
  }

  getAll (regionId, startDate, endDate) {
    if (this.cachedPriceLists[regionId] &&
      this.priceListCacheTimes[regionId] &&
      this.checkDate(this.cachedPriceLists[regionId], startDate, endDate) &&
      moment().diff(this.priceListCacheTimes[regionId], 'seconds') < this.cacheTimeNormal
    ) {
      return Promise.resolve(this.cachedPriceLists[regionId])
    }

   // return Promise.resolve({})

    let params = {}
    params.request = 'getSupplierPriceLists'
    params.searchAttributeName = 'store_region_id'
    params.searchAttributeValue = regionId
    //console.log('getSingle getSupplierListPrice params')
    //console.log(params)
    return this.connection.postErply(params)
      .then(response => (response.data.records))
      .then(priceLists => {
        //console.log('getSingle getSupplierListPrice priceLists')
        //console.log(priceLists)


        let regionalSuppliersPricelists = priceLists || []
        let periodsPriceList = this.filterByDate(regionalSuppliersPricelists, startDate, endDate)//[0]
        if (typeof periodsPriceList === undefined || !periodsPriceList) periodsPriceList = {pricelistRules: []}

        this.cachedPriceLists[regionId] = periodsPriceList
        this.priceListCacheTimes[regionId] = moment()
        return periodsPriceList
      })
      .catch(response => this.handleErrorResponse(response))
  }

  filterByDate (dateables, startDate, endDate) {
    let filtered = dateables.filter(dateable => {
      return this.checkDate(dateable, startDate, endDate)
    })

    //console.log('filterByDate filtered: ', filtered)

    let ordered = filtered.sort((a, b) => {
      let distancea = Math.abs(moment(a.startDate).diff(moment(startDate)))
      let distanceb = Math.abs(moment(b.startDate).diff(moment(startDate)))
      return distancea - distanceb//(moment(a.startDate).diff(moment(b.startDate)))//distancea - distanceb
    })
    //console.log('filterByDate ordered: ', ordered)

    return ordered
  }


  checkDate (dateable, startDate, endDate) {
    //console.log('checkDate dateable: ', dateable)
    //console.log('checkDate startDate: ', startDate)
    //console.log('checkDate endDate: ', endDate)
    if (dateable.startDate === '0000-00-00') {
      dateable.startDate = null
    }
    if (dateable.endDate === '0000-00-00') {
      dateable.endDate = null
    }
    // esli u pricelsit est start date i startdate bolshe "end date" - ne correctno
    if (dateable.startDate && dateable.startDate > endDate) {
      //console.log('checkDate false 1');
      return false
    //  esli est pricelist end date i enddate menshe start date - nekorrektno
    } else if (dateable.endDate && dateable.endDate < startDate) {
      //console.log('checkDate false 2');
      return false
    } else {
      //console.log('checkDate true');
      return true
    }
  }
}
export default RegionSupplierPriceLists



// WEBPACK FOOTER //
// ./src/api/Service/RegionSupplierPriceLists.js